export default `
fragment UserBlockFragment on user_blocks {
  id
  userId:user_id
  blockedUserId:blocked_user_id
}
`;
